// extracted by mini-css-extract-plugin
export default {"spinner":"styles_spinner__nMLUs","spinner__circle":"styles_spinner__circle__ksFdz","spin":"styles_spin__F9sVA"};